import { ButtonLevel } from '@zipari/shared-ds-util-button';
import { NavigationLinkTargets } from '@zipari/shared-ds-util-navigation';

export interface SsoPaymentConfig {
  sso_url: string;
  sso_cta_content: string;
  sso_cta_level: ButtonLevel;
  sso_cta_icon: string;
  sso_text?: string;
  sso_modal_title: string;
  sso_cancel: string;
  sso_proceed: string;
  sso_disclaimer: string;
  sso_image_url?: string;
  sso_target?: NavigationLinkTargets;
}

export interface SsoExternalConfig {
  title: string;
  description: string;
  footerCancelButton: string;
  footerProceedButton: string;
}
